const messageType = {
  gif: 0,
  image: 1,
  video: 2,
  text: 3,
};

export default messageType;
